import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import Global from './Global'
import Cable from './Cable'
import Account from './Account'

const store = new Vuex.Store({
  modules: {
    Global,
    Cable,
    Account,
  },
  strict: process.env.NODE_ENV !== 'production',
  // strict: false
})

export default store